import { render } from "./InviteOthers.vue?vue&type=template&id=18637c96&scoped=true"
import script from "./InviteOthers.vue?vue&type=script&lang=js"
export * from "./InviteOthers.vue?vue&type=script&lang=js"

import "./InviteOthers.vue?vue&type=style&index=0&id=18637c96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18637c96"]])

export default __exports__